import { useTranslations } from 'next-intl';

export const HeaderBanner = () => {
	const t = useTranslations('General');

	return (
		<div className="survey-header">
			<div className="survey-header__text" 
				dangerouslySetInnerHTML={{ __html: t.raw('lbl_GSabaSurveyDes') }}
			>
			</div>
		</div>
	)
}